import FormId from '@furnish-hx/constants/FormId';
import { IFormFieldKey, IFormFieldContactKey } from '../interfaces/Form';
import IStep from '../interfaces/IStep';
import MaterialTintId from './MaterialTintId';

export enum ActionId {
    CLICK = 'click',
    EDIT = 'edit',
    SET = 'set',
    OPEN_SLIDER = 'open_slider',
    CLOSE_SLIDER = 'close_slider',
    FILTER_MATERIAL = 'filter_material',
    SELECT_MATERIAL_CATEGORY = 'select_material_category',
    SELECT_MATERIAL_CLASS = 'select_material_class',
    SELECT_MATERIAL_ID = 'select_material_id',
    SUBMIT = 'submit',
    REQUEST_RESET_PASSWORD = 'request_reset_password',
    RESET_PASSWORD = 'reset_password',
}

export type CtaId = ButtonId | FormId | IStep | MaterialTintId;

export enum ButtonId {
    START = 'start',
    YES = 'yes',
    NO = 'no',
    LOAD_MORE = 'load_more',
    CONTINUE_ON_LILM = 'continue_on_lilm',
    SIGN_ME_UP = 'sign_me_up',
    ESTIMATION_ACCEPT = 'estimation_accept',
    ESTIMATION_REFUSE = 'estimation_refuse',
    CONTACT_ARTISAN = 'contact_artisan',
    ARTISAN_MAILTO = 'artisan_mailto',
    ARTISAN_PHONE = 'artisan_phone',
    CONTACT_USER = 'contact_user',
    USER_MAILTO = 'user_mailto',
    USER_PHONE = 'user_phone',
    ARTISANPROJECT_SUBMIT = 'artisanproject_submit',
}

export enum FromId {
    NAV = 'nav',
    STYLE = 'style',
    HOME = 'home',
    EDIT_COMPONENT = 'edit_component',
    WITH_EXTENSION = 'with_extension',
    HAS_BUDGET = 'has_budget',
    HAS_COMMENT = 'has_comment',
    UPLOAD_FILE = 'upload_file',
    SELECT_SHAPE = 'select_shape',
    SELECT_MATERIAL_CATEGORY = 'select_material_category',
    SELECT_MATERIAL_CLASS = 'select_material_class',
    SELECT_MATERIAL = 'select_material',
}

export enum ValueType {
    SIMPLE = 'simple',
    MATERIAL = 'material',
    DIMENSION = 'dimension'
}

export type DataId = IFormFieldKey | IFormFieldContactKey | ExtraDataId;

export enum ExtraDataId {
    BUDGET = 'budget',
}

export enum UserProperty {
    PERSONA = 'persona',
}

export default ActionId;
